import { ITossPayment } from '../models/toss.model';

export const getTossInstallment = (installment: string): string => {
  if (installment === '일시불') {
    return '00';
  }

  return ('00' + installment.substr(0, 2).trim()).slice(-2);
};

export const responseDataParse = (result: string): ITossPayment => {
  return JSON.parse(result.replace(/\\/gi, ''));
};
